<template>
  <div id="depot">
    <DepotList />

    <div class="search">
      <div class="cs-searchbar">
        <i class="cs-search"></i>
        <input
          class="form-control"
          type="search"
          placeholder="Zoeken een depot"
        />
      </div>

      <div class="search-filters">
        <ul>
          <li>
            <a
              class="nav-link"
              href="#"
              id="profiledropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div class="form-check">
                <input
                  class="form-check-input"
                  name="dekking"
                  type="radio"
                  value=""
                  id="dekking"
                />
                <label class="form-check-label" for="dekking"
                  ><span></span>Dekking</label
                >
              </div>
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
              <ul>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="dekking"
                    type="radio"
                    value=""
                    id="citroen"
                  />
                  <label class="form-check-label" for="citroen"
                    ><span></span>Toon waar te weinig</label
                  >
                </li>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="dekking"
                    type="radio"
                    value=""
                    id="fiat"
                  />
                  <label class="form-check-label" for="fiat"
                    ><span></span>Toon waar te veel</label
                  >
                </li>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="dekking"
                    type="radio"
                    value=""
                    id="ford"
                  />
                  <label class="form-check-label" for="ford"
                    ><span></span>Toon waar binnen limieten</label
                  >
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a
              class="nav-link"
              href="#"
              id="profiledropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div class="form-check">
                <input
                  class="form-check-input"
                  name="limieten"
                  type="radio"
                  value=""
                  id="limieten"
                />
                <label class="form-check-label" for="limieten"
                  ><span></span>Limieten</label
                >
              </div>
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
              <ul>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="limieten"
                    type="radio"
                    value=""
                    id="weinig"
                  />
                  <label class="form-check-label" for="weinig"
                    ><span></span>Toon waar te weinig</label
                  >
                </li>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="limieten"
                    type="radio"
                    value=""
                    id="veel"
                  />
                  <label class="form-check-label" for="veel"
                    ><span></span>Toon waar te veel</label
                  >
                </li>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="limieten"
                    type="radio"
                    value=""
                    id="binnenlimieten"
                  />
                  <label class="form-check-label" for="binnenlimieten"
                    ><span></span>Toon waar binnen limieten</label
                  >
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <MapComponent :models="depots" ref="map" />
  </div>
</template>

<script>
import DepotList from "./partials/DepotList";

import MapComponent from "@/components/map/MapComponent";
import DepotService from "@/services/DepotService";
import GoogleService from "@/services/GoogleService";

const depotService = new DepotService();
const googleService = new GoogleService();

export default {
  name: "depots",
  components: {
    DepotList,
    MapComponent
  },
  data() {
    return {
      depots: [],
      depots_focused: []
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    async search(search) {
      if (config.app.debug) {
        let coordinate = config.app.debug
          ? { lat: 51.5719149, lng: 4.768323 }
          : null;

        if (search) {
          coordinate = googleService.findByCity(search);
        }

        depotService
          .search(search, { coordinate: coordinate, meta: {} })
          .then(items => {
            this[this.depots.length ? "depots_focused" : "depots"] = items;

            if (this.$refs.map) {
              this.$refs.map.highlightMarkers(items);
              this.$refs.map.refreshClusters();
            }
          });

        if (coordinate) {
          this.$refs.map.panTo(coordinate);
        }
      }
    }
  }
};
</script>
